import React from "react";
import HomePage from "./views/home";

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <HomePage />
    </div>
  );
};

export default App;
